import { render, staticRenderFns } from "./CoverEditor.vue?vue&type=template&id=6826ff9e"
import script from "./CoverEditor.vue?vue&type=script&lang=js"
export * from "./CoverEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports